import { isEnvFeatureEnabled } from '@app/enviroment/enviroment';

// Off unless the tenant sets EXTERNAL_PROVIDERS_ENABLED=true. Existing provider names on
// visits still render when it is off; only the authoring and management surfaces hide.
export const isExternalProvidersEnabled = (): boolean => isEnvFeatureEnabled('EXTERNAL_PROVIDERS_ENABLED');
